// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import setReturnNotes from "@insite/client-framework/Store/Pages/RequestRma/Handlers/SetReturnNotes";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import StyledBox from "@conklin/XDL/Components/Common/Box";
import React, { FC, useContext } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    returnNotes: state.pages.requestRma.returnNotes,
});

const mapDispatchToProps = {
    setReturnNotes,
};

export interface RequestRmaNotesStyles {
    wrapper?: InjectableCss;
    notesTextArea?: TextAreaProps;
    // XNG-Changes
    titleText?: TypographyProps;
}

export const notesStyles: RequestRmaNotesStyles = {
    wrapper: {
        css: css`
            padding-bottom: 20px;
        `,
    },
};

const styles = notesStyles;

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const RequestRmaNotes: FC<Props> = ({ returnNotes, setReturnNotes }) => {
    const { value: order } = useContext(OrderStateContext);
    if (!order) {
        return null;
    }

    const changeHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setReturnNotes({ returnNotes: event.currentTarget.value });
    };

    // XNG-Changes: using styledBox
    return (
        <StyledBox>
            <Typography {...styles.titleText}>{translate("Return Request")}</Typography>
            <TextArea
                label={translate("Return Notes")}
                value={returnNotes}
                rows={5}
                placeholder={translate("Enter your notes here")}
                onChange={changeHandler}
                {...styles.notesTextArea}
            />
            {/* XNG-Changes */}
            {/* <RequestRmaButtons extendedStyles={styles.requestRmaButtons} /> */}
        </StyledBox>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RequestRmaNotes),
    definition: {
        allowedContexts: ["RequestRmaPage"],
        group: "Return Request (RMA)",
        displayName: "Notes",
        fieldDefinitions: [],
    },
};

export default widgetModule;
